import { useCallback, useState } from 'react';
import { loadMainImage } from '../utils/tourUtils';

export const useRoomImageCache = () => {
  const [roomImages, setRoomImages] = useState({});
  const [loadingRoomId, setLoadingRoomId] = useState(null); // 🛠 properly manage this

  const loadAndCacheImage = useCallback(async (tour, roomId) => {
    setLoadingRoomId(roomId);
    try {
      const url = await loadMainImage(tour, roomId);
      const res = await fetch(url);
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      setRoomImages(prev => ({ ...prev, [roomId]: objectUrl }));
      return objectUrl;
    } catch (err) {
      console.error(`Failed to load image for room ${roomId}`, err);
      return null;
    } finally {
      setLoadingRoomId(null);
    }
  }, []);

  const loadFirstRoomImage = useCallback((tour, roomId) => loadAndCacheImage(tour, roomId), []);
  const preloadImages = useCallback(
    async (tour, rooms) => {
      for (const room of rooms) {
        if (roomImages[room.id]) continue;
        await loadAndCacheImage(tour, room.id); // ✅ this ensures cache is updated properly
      }
    },
    [loadAndCacheImage, roomImages]
  );

  const getCachedImage = useCallback(id => roomImages[id], [roomImages]);

  return {
    roomImages,
    loadingRoomId,
    loadAndCacheImage,
    loadFirstRoomImage,
    preloadImages,
    getCachedImage,
  };
};
